import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useMyContextLoading } from "../../../../components/LoadingContextProvider/LoadingContextProvider"
import { getPublicIP } from "../../../../utils/ip"
import { showSnackBar } from "../../../../components/Snackbar/Snackbar"
import ModalComponent from "../../../../components/Modal/Modal"
import { areFieldsNotEmpty } from "../../../../helpers/helper"
import UploadContainer from "../../../../components/UploadContainer/UploadContainer"
import BluePlusIcon from "../../../../assets/images/icons/BluePlusIcon.svg"
import { uploadLSAMainDoc } from "../../../../features/documents/documents"


const UploadLSADocumentModal = ({ userId, isSignedMainDoc, checkUserBankAccountAndSigningInfo, signingBlocked }) => {

  const dispatch = useDispatch()
  const [reqError, setReqError] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const { triggerLoading } = useMyContextLoading()
  const [publicIP, setPublicIP] = useState("Loading...")

  useEffect(() => {
    getPublicIP().then(setPublicIP)
  }, [])

  const [closeModalOnSubmit, setCloseModalOnSubmit] = useState(true)
  const [formData, setFormData] = useState({
    name: '',
    type: '',
    file: ''
  })
  const resetFormData = () => {
    setFormData(
      {
        name: '',
        type: '',
        file: '',
      }
    )
  }
  useEffect(() => {
    const handleReqError = () => {
      reqError?.length > 0 && showSnackBar("error", reqError)
      setReqError('')
    }

    handleReqError()
  }, [reqError])

  const handleInputChange = ({ name, value }) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }))
  }

  const uploadDocument = async () => {
    if (isSignedMainDoc || signingBlocked || submitting) {
      return
    }
    setSubmitting(true)
    triggerLoading(true)
    try {
      const response = await dispatch(uploadLSAMainDoc({
        body: formData,
        fileType: formData?.file?.type.split("/")[1],
        ip: publicIP,
        userId
      }))
      if (response.error) {
        setReqError(response.payload)
      } else {
        showSnackBar("success", "The document is successfully uploaded")
        await checkUserBankAccountAndSigningInfo({ custUserId: userId })
      }
    } finally {
      triggerLoading(false)
      setSubmitting(false)
    }
  }


  return (
    <ModalComponent iconButton={BluePlusIcon} buttonTitle="Upload LSA" modalButtonTitle="Submit"
      title="Upload LSA Document" functionButton={uploadDocument}
      disabled={isSignedMainDoc || submitting || signingBlocked || !areFieldsNotEmpty([formData?.file?.name])}
      onClose={resetFormData} buttonType="outlined"
      buttonClasses="border mr-[10px] !border-primary-main h-full text-md"
      closeOnSubmit={closeModalOnSubmit}>
      <div className="max-w-[630px]">
        <div className="grid mb-6 h-100">
          <UploadContainer
            backFile={(file) => handleInputChange({ name: 'file', value: file })}
            className="mt-6" typeFiles=".pdf, .docx, .doc, .png, .jpeg, .jpg " title="Select a File"
            titleTypeFiles=".pdf, .docx, .doc, .png, .jpeg, .jpg" />
        </div>
      </div>
    </ModalComponent>
  )
}
export default UploadLSADocumentModal
